import clsx from 'clsx';
import React from 'react';

import type { CardSubtitleProps } from './Card.types';

export const CardSubtitle = React.forwardRef<HTMLElement, CardSubtitleProps>(
  ({ as: Component = 'p', size = 'medium', testId, ...restProps }, ref) => {
    return (
      <Component
        ref={ref}
        className={clsx('hg-card__subtitle', {
          [`hg-card__subtitle--${size}`]: size !== 'medium',
        })}
        size={size}
        data-testid={testId}
        {...restProps}
      />
    );
  }
);

CardSubtitle.displayName = 'Card.Subtitle';
